import React from 'lib/react';
import {
  EVGrid, makeStyles, EVTypography, EVButton,
} from '@eagleview/ev-comp-library';
import { useTranslation } from 'lib/translation';
import { useDispatch } from 'lib/redux';
import PropTypes from 'prop-types';
import clsx from 'lib/clsx';

const useStyles = makeStyles((theme) => ({
  retryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    '&.recentOrders': {
      padding: '16px 24px',
      '@media (min-width: 640px)': {
        padding: '0px',
      },
    },
  },
  retryText: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
  retryBtn: {
    textTransform: 'capitalize',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'fit-content',
    },
  },
}));

function DashboardRetry({ retryText, action, type = '' }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleRetryClick = () => {
    dispatch({ type: action });
  };

  return (
    <EVGrid container className={clsx(classes.retryContainer, type)}>
      <EVTypography className={classes.retryText}>{retryText}</EVTypography>
      <EVButton
        id={`${retryText}-retryBtn`}
        onClick={handleRetryClick}
        variant="outlined"
        color="primary"
        className={classes.retryBtn}
      >
        {t('order_history__retry')}
      </EVButton>
    </EVGrid>
  );
}
DashboardRetry.propTypes = {
  type: PropTypes.string.isRequired,
  retryText: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export default DashboardRetry;
